// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1ir_j","errorLogs":"styles_errorLogs__31lic"};